<template>
    <div class="poster">
        <div class="title">
            <p>产品管理</p>
        </div>
        <div class="main">
            <div class="form">
                <el-form ref="formInline" :inline="true" :model="formInline" class="demo-form-inline">
                    <div>
                        <el-form-item>
                            <el-input v-show="activeName == 'product'" v-model="formInline.id" placeholder="请输入编号ID" clearable></el-input>
                        </el-form-item>
                        <el-form-item v-show="activeName == 'product'">
                            <el-input v-model="formInline.brand_name" placeholder="请输入品牌名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item v-show="activeName == 'product'">
                            <el-input v-model="formInline.agency_name" placeholder="请输入经销商名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item v-show="activeName == 'product'">
                            <el-select v-model="formInline.status" @change="statusChange" placeholder="请选择状态">
                                <el-option :value="0" label="全部"></el-option>
                                <el-option :value="1" label="正常"></el-option>
                                <el-option :value="2" label="停权"></el-option>
                                <el-option :value="3" label="禁售"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-show="activeName == 'class'" v-model="formInline.class_id" placeholder="请输入编号ID" clearable></el-input>
                        </el-form-item>
                        <el-form-item v-show="activeName == 'class'">
                            <el-input v-model="formInline.class_name" placeholder="请输入分类名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item v-show="activeName == 'class'">
                            <el-cascader
                                placeholder="请输入分类类型"
                                clearable
                                @change="levelChange"
                                collapse-tags
                                :options="treeData"
                                :props="{ multiple: true, expandTrigger: 'hover', label: 'name', value: 'id' }"
                                :show-all-levels="false"
                            ></el-cascader>
                        </el-form-item>
                    </div>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main table">
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="产品管理" name="product"></el-tab-pane>
                    <el-tab-pane label="分类管理" name="class"></el-tab-pane>
                </el-tabs>
                <div class="btnlist" v-show="activeName == 'class'">
                    <el-button type="primary" size="medium" @click="showCreateOrEditDia(0)">+ 添加一级分类</el-button>
                </div>
            </div>
            <div class="table">
                <Table
                    ref="refTable"
                    :page="page"
                    :total="total"
                    :size="size"
                    :tabload="tabload"
                    :tableData="tableData"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    @operate="operate"
                    @detail="detail"
                    @showCreateOrEditDia="showCreateOrEditDia"
                    @deleteCategory="deleteCategory"
                    :_type="activeName"
                ></Table>
            </div>
        </div>
        <Detail ref="refDetail"></Detail>
        <Operate ref="refOperate" @init="getList(1)"></Operate>
        <CreateLevelOrEdit ref="refCreateLevelOrEdit" @init="getList(1)"></CreateLevelOrEdit>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import CreateLevelOrEdit from "@/components/Modules/ProductManagement/CreateLevelOrEdit.vue";
import Detail from "@/components/Modules/ProductManagement/Detail.vue";
import Table from "@/components/Modules/ProductManagement/Table.vue";
import Operate from "@/components/Modules/ProductManagement/Operate.vue";
import Qs from "qs";
export default {
    components: {
        Detail,
        Operate,
        CreateLevelOrEdit,
        Table,
    },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            tableData: [],
            formInline: {
                id: "",
                agency_name: "",
                brand_name: "",
                status: "",
                class_name: "",
                class_id: "",
                level: "",
            },
            activeName: "product",
            treeData: [],
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.activeName = this.$route.query.type || "product";
        this.getTree();
        this.getList(1);
    },
    methods: {
        ...mapActions({
            productList: "brand/getAgencyProductList",
            getCategoryList: "brand/getCategoryList",
            getTreeList: "brand/getTreeList",
            deleteCategoryApi: "brand/deleteCategory",
        }),
        levelChange(val) {
            // console.log(val);
            let arr = [];
            val.forEach((item) => {
                arr.push(item[item.length - 1]);
            });
            this.formInline.level = arr.toString();
        },
        getTree() {
            let opt = {
                token: this.getToken,
                page: 0, //当前页数
                size: 0, //每页显示条数
            };
            this.getTreeList(opt).then(({ data }) => {
                if (data.code == 1) {
                    this.treeData = data.data.treeData;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        deleteCategory(id) {
            this.$confirm("此操作将删除此条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.deleteCategoryApi({ token: this.getToken, id: id }).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getList();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        showCreateOrEditDia(row, type_str) {
            this.$refs.refCreateLevelOrEdit.dialogVisible = true;
            this.$refs.refCreateLevelOrEdit.bindData(row, type_str);
        },
        // 添加一级分类

        // 操作
        operate(row) {
            this.$refs.refOperate.dialogVisible = true;
            this.$refs.refOperate.dataBind(row);
        },
        // 详情页
        detail(id) {
            this.$refs.refDetail.dialogVisible = true;
            this.$refs.refDetail.getTable(id);
        },
        // 获取表格数据
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                page: tag == 1 ? tag : this.page,
                size: this.size,
            };
            let url;
            if (this.activeName == "product") {
                url = this.productList;
                (opt.not_agency_id = 0), (opt.id = this.formInline.id);
                opt.agency_name = this.formInline.agency_name;
                opt.brand_name = this.formInline.brand_name;
                opt.status = this.formInline.status == 0 ? null : this.formInline.status;
            } else if (this.activeName == "class") {
                url = this.getCategoryList;
                opt.name = this.formInline.class_name;
                opt.id = this.formInline.level || this.formInline.class_id;
            }
            url(Qs.stringify(opt)).then(({ data }) => {
                this.tabload = false;
                if (data.code == 1) {
                    this.tableData = [];
                    this.tableData = data.data.list;
                    this.total = data.data.count ? data.data.count : 0;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 表格每页显示数量改变
        handleSizeChange(val) {
            this.size = val;
            this.$nextTick(() => {
                this.getList();
            });
        },
        // 切换page
        handleCurrentChange(val) {
            this.page = val;
            this.$nextTick(() => {
                this.getList();
            });
        },
        // 搜索
        onSubmit() {
            this.getList(1);
        },
        // 重置
        reset() {
            this.$refs.formInline.resetFields();
            this.formInline = {
                id: "",
                agency_name: "",
                brand_name: "",
                status: "",
                class_name: "",
                class_id: "",
                level: "",
            };
            this.getList(1);
        },
        // 类型切换
        handleClick() {
            this.tableData = [];
            this.tabload = true;
            this.getList(1);
        },
        // 查询状态改变
        statusChange() {
            this.getList();
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px;
    }
    ::v-deep .el-tabs__active-bar {
        width: 120px;
    }

    ::v-deep .el-tabs__item {
        width: 120px;
        text-align: center;
        padding: 0;
    }

    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;

        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .main.table {
        min-width: 1200px;
        min-height: 600px;
        .table {
            min-height: 500px;
        }
    }
    .main {
        min-width: 1200px;
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;

        .tabs {
            position: relative;
        }
        .btnlist {
            position: absolute;
            right: 0;
            bottom: 28px;
        }
        span {
            margin-right: 10px;
            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }
    }
    .el-form {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: -22px;
    }
}
</style>